import { render, staticRenderFns } from "./examStats.vue?vue&type=template&id=62823ffe&scoped=true&"
import script from "./examStats.vue?vue&type=script&lang=js&"
export * from "./examStats.vue?vue&type=script&lang=js&"
import style0 from "./examStats.vue?vue&type=style&index=0&id=62823ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62823ffe",
  null
  
)

export default component.exports